module.exports = __webpack_public_path__ + "static/img/gnp.541bc23.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/payment/gnp.png
// module id = 7kW+
// module chunks = 1